import { useState } from "react"

const CoursePlayerSidebar = ({ course, currentLesson, onLessonSelect, isOpen, onClose }) => {
  const [expandedModules, setExpandedModules] = useState(() => {
    const initialExpanded = {}
    course.modules.forEach(module => {
      initialExpanded[module.id] = false
    })
    return initialExpanded
  })
  

  // Local lesson completion state for demo; replace with API if needed
  const [lessonCompletion, setLessonCompletion] = useState(() =>
    Object.fromEntries(
      course.modules.flatMap(m =>
        (m.lessons || []).map(l => [l.id, !!l.completed])
      )
    )
  );

  const toggleModule = (moduleId) => {
    setExpandedModules((prev) => ({
      ...prev,
      [moduleId]: !prev[moduleId],
    }))
  }

  const getLessonIcon = (contentType, completed) => {
    const baseClass = completed ? "text-success" : "text-muted"
    switch (contentType) {
      case "video":
        return `fas fa-play-circle ${baseClass}`
      case "doc":
        return `fas fa-file-alt ${baseClass}`
      case "quiz":
        return `fas fa-question-circle ${completed ? baseClass : "text-danger"}`
      default:
        return `fas fa-file ${baseClass}`
    }
  }

  const getCompletionIcon = (completed) => {
    return completed ? (
      <i className="fas fa-check-circle text-success"></i>
    ) : (
      <i className="far fa-circle text-muted"></i>
    )
  }

  const calculateModuleProgress = (module) => {
    if (!module.lessons || module.lessons.length === 0) return "0/0"
    const completed = module.lessons.filter(lesson => lessonCompletion[lesson.id]).length
    return `${completed}/${module.lessons.length}`
  }

  // Only mark as completed when clicking the icon
  const handleCompletionToggle = (lessonId, e) => {
    e.stopPropagation(); // Don't trigger lesson select
    setLessonCompletion(prev => ({
      ...prev,
      [lessonId]: !prev[lessonId],
    }))
    // TODO: Add API call here if required
  }

  return (
    <>
    <div className={`course-player-sidebar ${isOpen ? "open" : ""}`}>
      <div className="sidebar-header">
        <h6 className="mb-0">Course Content</h6>
      </div>

      <div className="sidebar-content">
        {course.modules.map((module) => (
          <div key={module.id} className="module-section">
            <div
              className="module-header"
              onClick={() => module.lessons && module.lessons.length > 0 && toggleModule(module.id)}
              style={{ cursor: module.lessons && module.lessons.length > 0 ? "pointer" : "default" }}
            >
              <div className="d-flex align-items-center flex-grow-1">
                <span className="module-title">{module.title}</span>
              </div>
              <div className="d-flex align-items-center">
                <span className="module-progress me-2">{calculateModuleProgress(module)}</span>
                {module.lessons && module.lessons.length > 0 && (
                  <i className={`fas ${expandedModules[module.id] ? "fa-chevron-up" : "fa-chevron-down"}`}></i>
                )}
              </div>
            </div>

            {expandedModules[module.id] && module.lessons && module.lessons.length > 0 && (
              <div className="lessons-list">
                {module.lessons.map((lesson) => (
                  <div
                    key={lesson.id}
                    className={`lesson-item ${currentLesson?.id === lesson.id ? "active" : ""}`}
                    onClick={() => {
                      onLessonSelect(lesson);
                      if (onClose) onClose();
                    }}
                  >
                    <div className="lesson-content">
                      <div className="d-flex align-items-center">
                        <i className={`${getLessonIcon(lesson.content_type, lessonCompletion[lesson.id])} me-3`}></i>
                        <span className="lesson-title flex-grow-1 mx-2">{lesson.title}</span>
                        <div className="lesson-meta d-flex align-items-center">
                          <span
                            onClick={e => handleCompletionToggle(lesson.id, e)}
                            style={{ cursor: "pointer" }}
                            title={lessonCompletion[lesson.id] ? "Mark as incomplete" : "Mark as complete"}
                          >
                            {getCompletionIcon(lessonCompletion[lesson.id])}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>

    {/* Overlay for mobile */}
  {isOpen && (
    <div className="sidebar-overlay" onClick={onClose}></div>
  )}
  </>
  )
}

export default CoursePlayerSidebar
